import { createSlice } from '@reduxjs/toolkit';
import {
  getAllCustomFail,
  getAllCustomPending,
  getAllCustomSuccess,
  INITIAL_STATE_CUSTOM,
  resetResourceDataCustom,
} from 'redux/crudCreatorCustom/utils';
import { getCentresOfMeBasic } from './actions';

export const initialState = {
  ...INITIAL_STATE_CUSTOM,
};

const { actions, reducer } = createSlice({
  name: 'CentresOfMeBasic',
  initialState,
  reducers: {
    resetResourceFilterCentresOfMeBasic: resetResourceDataCustom,
  },
  extraReducers: {
    [getCentresOfMeBasic.pending]: getAllCustomPending,
    [getCentresOfMeBasic.fulfilled]: getAllCustomSuccess,
    [getCentresOfMeBasic.rejected]: getAllCustomFail,
  },
});

export const { resetResourceFilterCentresOfMeBasic } = actions;

export default reducer;
